import Game from 'Game';
import { ContextType } from 'State/Game/ContextType';
import { GameActions } from 'State/Game/GameActions';
import ITask from './ITask';

export default class ContextTask implements ITask<any> {
    private contextType: ContextType;
    private data?: {};
    constructor(contextType: ContextType, data?: {}) {
        this.contextType = contextType;
        this.data = data;
    }

    public *execute(): IterableIterator<any> {
        GameActions.setContext(this.contextType, this.data);
        let contextRestored = false;
        Game.store.waitFor(GameActions.restoreContext).then(() => {
            contextRestored = true;
        });

        while (!contextRestored) {
            yield;
        }
    }
}
